import React from 'react'
import { observer } from 'mobx-react-lite'
import { Instance } from 'mobx-state-tree'
import { ISelectorOption } from '@trivie/core'
import { AssignmentCreateForm } from '@trivie/core/src/models/AssignmentCreateForm'
import { AutocompleteSelector } from '../../../../components/autocomplete-selector'

type AssignmentAssigneesProps = {
  form: Instance<typeof AssignmentCreateForm>
  editingId?: any
}

export const AssignmentAssignees = observer((props: AssignmentAssigneesProps) => {
  const { form, editingId } = props

  const preselectIds = editingId
    ? [
        ...((form.users as any[]) ?? []).map((u: any) => ({ id: u.id, type: 'Users' })),
        ...((form.groups as any[]) ?? []).map((g: any) => ({
          id: g.group_id ?? g.id,
          type: 'Groups',
        })),
      ]
    : undefined

  const defaultOpts = !editingId
    ? [
        ...((form.groups as any[]) ?? []).filter((f: any) => f.label),
        ...((form.users as any[]) ?? []).filter((f: any) => f.label),
      ]
    : undefined

  const handleSelectionChange = (selected: ISelectorOption[]) => {
    form.set('groups', selected.filter((s) => s.type === 'Groups') as any)
    form.set('users', selected.filter((s) => s.type === 'Users') as any)
  }

  return (
    <AutocompleteSelector
      variant="users-groups"
      open
      preselectIds={preselectIds}
      defaultOptions={defaultOpts as ISelectorOption[]}
      onSelectionChange={handleSelectionChange}
      style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
    />
  )
})
